import { render } from "./UsersListPage.vue?vue&type=template&id=05939522&scoped=true&ts=true"
import script from "./UsersListPage.vue?vue&type=script&lang=ts"
export * from "./UsersListPage.vue?vue&type=script&lang=ts"

import "./UsersListPage.vue?vue&type=style&index=0&id=05939522&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05939522"]])

export default __exports__